import { render } from "./PwaInstallButton.vue?vue&type=template&id=27ac851b&scoped=true"
import script from "./PwaInstallButton.vue?vue&type=script&lang=js"
export * from "./PwaInstallButton.vue?vue&type=script&lang=js"

import "./PwaInstallButton.vue?vue&type=style&index=0&id=27ac851b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ac851b"]])

export default __exports__